<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Tabs :value="currentRoute" @on-click="changeRouter" :loading="$store.state.Convert.syncing">
        <TabPane name="tencentv3ad" label="单元"></TabPane>
        <TabPane name="toutiaov3creative" label="创意"></TabPane>
      </Tabs>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'TencentDefault',
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      if (this.$route.name === 'tencentplanv3') this.changeRouter('tencentv3ad')
      this.currentRoute = this.$route.name
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: ''
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
